import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import numeral from "numeral"
import settings from "settings"
import Modal from "react-responsive-modal"
import helpers from "helpers/helpers"

class ClosingsOverview extends Component {
	constructor(props) {
		super(props)
		this.state = {
			journeyModal: false,
			journey: null,
			closings: [],
			basePricing: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Number of Closings",
					accessor: "count",
					filterMethod: (f, r) => helpers.tableText(f, r, "count"),
				},
				{
					Header: "Average Difference Dollars",
					accessor: "average",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					Footer: (f, r) => {
						if (_.has(f, "data[0]._original.allGross")) {
							return numeral(f.data[0]._original.allGross / f.data[0]._original.allCount).format("$0,0")
						}
						return ""
					},
				},
				{
					Header: "Percent Change",
					accessor: "percent",
					Cell: (v) => {
						return numeral(v.value / 100).format("0,0.00%")
					},
					Footer: (f, r) => helpers.tableAverages(f, "percent", "0,0.00%"),
				},
			],
			detailedColumns: [
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "School District",
					accessor: "isd",
					filterMethod: (f, r) => helpers.tableText(f, r, "isd"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Buyer Email",
					accessor: "buyer_email",
				},
				{
					Header: "Buyer First",
					accessor: "primary_first",
				},
				{
					Header: "Buyer Last",
					accessor: "primary_last",
				},
				{
					Header: "Co First",
					accessor: "co_first",
				},
				{
					Header: "Co Last",
					accessor: "co_last",
				},
				{
					Header: "Co Email",
					accessor: "co_email",
				},
				{
					Header: "Buyer Age",
					accessor: "primary_age",
				},
				{
					Header: "Copilot Traffic",
					accessor: "is_copilot_closing",
					Cell: (props) => {
						return props.value ? "Yes" : "No"
					},
				},
				{
					Header: "Realtor",
					accessor: "realtor",
				},
				{
					Header: "Contract Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
				},
				{
					Header: "Closing Price",
					accessor: "closing_price",
					Cell: (props) => numeral(props.value).format("$0,0"),
				},
				{
					Header: "Sq. Ft.",
					accessor: "sqft",
					Cell: (props) => numeral(props.value).format("0,0"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Closed Date",
					accessor: "closing_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Welcome Host",
					accessor: "host",
					filterMethod: (f, r) => helpers.tableText(f, r, "host"),
				},
				{
					Header: "Days to Close",
					accessor: "days_to_close",
					filterMethod: (f, r) => helpers.tableText(f, r, "days_to_close"),
					Footer: (props) => helpers.tableAverages(props, "days_to_close", "0,0"),
				},
				{
					Header: "Input Date",
					accessor: "inputDate",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Closing vs Report",
					accessor: "closing_v_report",
				},
			],
			sectionColumns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Total Closings",
					accessor: "totals",
					filterMethod: (f, r) => helpers.tableText(f, r, "totals"),
				},
			],
			neighborhoodColumns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Total Closings",
					accessor: "totals",
					filterMethod: (f, r) => helpers.tableText(f, r, "totals"),
				},
			],
			prospectJourney: [
				{
					Header: "Buyer",
					accessor: "buyer",
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer"),
				},
				{
					Header: "Email",
					accessor: "email",
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Path",
					accessor: "path",
				},
			],
		}
	}

	buildTable = () => {
		var ret = []

		if (_.has(this.props, "payload.closings.current")) {
			this.props.payload.closings.current.forEach((r) => {
				var v = {}
				let sp = _.find(this.props.payload.public.salespeople, {
					id: r.salesperson,
				})
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				v.event = "Closed Home"
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.address = r.address
				v.builder = builder ? builder.name : ""
				v.closing_date = r.closing_date
				v.closing_report_time = r.closing_report_time
				v.sale_date = r.sale_date

				ret.push(v)
			})
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildSections = () => {
		let ret = []
		let store = {}

		_.forEach(this.props.payload.closings.current, (v) => {
			let prop = _.find(this.props.payload.public.properties, { id: v.property })
			let sec = _.find(this.props.payload.public.sections, { id: v.section_id })
			if (prop && sec) {
				let path = `${prop.name}.${sec.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
				store[prop.name][sec.name]++
			}
		})

		_.forEach(store, (v1, propName) => {
			_.forEach(v1, (v2, section) => {
				ret.push({
					community: propName,
					section,
					totals: v2,
				})
			})
		})

		return ret
	}

	buildNeighborhoods = () => {
		let ret = []
		let store = {}
		_.forEach(this.props.payload.closings.current, (v) => {
			let prop = _.find(this.props.payload.public.properties, { id: v.property })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })
			if (prop && neighborhood) {
				let path = `${prop.name}.${neighborhood.name}.${v.lotTypeName}`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
				store[prop.name][neighborhood.name][v.lotTypeName]++
			}
		})

		_.forEach(store, (v1, propName) => {
			_.forEach(v1, (v2, neighborhood) => {
				_.forEach(v2, (count, lotType) => {
					ret.push({
						community: propName,
						neighborhood,
						lot_type: lotType,
						totals: count,
					})
				})
			})
		})

		return ret
	}

	buildTotalSales = () => {
		if (_.has(this.props, "payload.closings.current")) {
			let d = {}
			_.forEach(this.props.payload.closings.current, (v) => {
				if (!d[v.builder]) {
					d[v.builder] = 0
				}
				d[v.builder]++
			})
			return _.map(d, (t, b) => {
				let builder = _.find(this.props.payload.public.builders.children, { id: t })
				if (!builder) {
					return
				}
				return (
					<li className="statBreakout__item" key={b}>
						<div>
							<div className="statBreakout__stat">{t}</div>
							<div className="statBreakout__info">{builder.name}</div>
						</div>
					</li>
				)
			})
		}
	}

	buildDetailed = () => {
		var ret = []
		for (let r of this.props.payload.closings.current) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let school = _.find(this.props.payload.public.isds, { id: r.isd })
			let section = _.find(this.props.payload.public.sections, { id: r.section_id })
			let neigh = _.find(this.props.payload.public.neighborhoods, { id: r.neighborhood })
			let sub = _.find(this.props.payload.public.subdivisions, { id: r.subdivision })
			let diff = moment.unix(r.closing_date).diff(moment.unix(r.sale_date), "days")
			v.subdivision = r.subdivisionName
			v.neighborhood = r.neighborhoodName
			v.lot_type = r.lotTypeName
			v.builder = builder
			v.sectionName = r.sectionName
			v.block = r.block
			v.lot = r.lot
			v.address = r.address
			v.salesperson = salesperson
			v.primary_age = r.primary_age
			v.is_copilot_closing = r.is_copilot_closing
			v.price = r.price
			v.closing_price = r.closing_price
			v.sqft = r.sqft
			v.contract_date = r.sale_date ? r.sale_date : ""
			v.closing_date = r.closing_date
			v.cancel_date = r.bustout_date
			v.inputDate = r.closing_report_time
			v.isd = school ? school.name : ""
			v.section = section ? section.name : ""
			v.neighborhood = neigh ? neigh.name : ""
			v.subdivision = sub ? sub.name : ""
			v.buyer_email = r.primary_email
			v.primary_first = r.primary_first
			v.primary_last = r.primary_last
			v.co_first = r.co_first
			v.co_last = r.co_last
			v.co_email = r.co_email
			v.realtor = r.realtor_name
			v.days_to_close = diff
			v.closing_v_report = moment.unix(r.closing_report_time).diff(moment.unix(r.closing_date), "days")

			let host
			// Check the primary buyer email for host first
			if (r.host) host = _.find(this.props.payload.public.info_center_users, { id: r.host })
			if (!host) {
				// if no host so far, check the co-buyer email
				if (r.traffic_co_host)
					host = _.find(this.props.payload.public.info_center_users, { id: r.traffic_co_host })
			}
			v.host = host ? `${host.first} ${host.last}` : ""

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildBasePricing = () => {
		let ret = []
		let store = {}
		let model = {
			count: 0,
			priceSum: 0,
			baseSum: 0,
		}
		let allGross = 0
		let allCount = 0
		_.forEach(this.props.payload.closings.current, (v) => {
			if (v.price && v.floorplan_base_price) {
				let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (!type || !builder) return
				let builderName = helpers.safeString(builder.name)
				let path = `${builderName}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[builderName][type.name].count++
				store[builderName][type.name].priceSum += v.price
				store[builderName][type.name].baseSum += v.floorplan_base_price

				allGross += v.price - v.floorplan_base_price
				allCount++
			}
		})
		_.forEach(store, (v1, builder) => {
			_.forEach(v1, (v2, lot_type) => {
				let diff = v2.priceSum - v2.baseSum
				let avg = diff / v2.count
				ret.push({
					average: avg,
					count: v2.count,
					percent: helpers.percentChange(v2.baseSum, v2.priceSum),
					builder,
					lot_type,
					allGross,
					allCount,
				})
			})
		})
		return ret
	}

	buildProspectJourney = () => {
		let ret = []

		_.forEach(this.props.payload.closings.current, (v) => {
			if (
				(Array.isArray(v.traffic_entries) && v.traffic_entries.length > 0) ||
				(Array.isArray(v.leads) && v.leads.length > 0)
			) {
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let section = _.find(this.props.payload.public.sections, { id: v.section_id })
				let salesperson = _.find(this.props.payload.users, { id: v.salesperson })
				ret.push({
					buyer: `${v.primary_first} ${v.primary_last}`,
					address: v.address,
					builder: builder ? builder.name : "",
					section: section ? section.name : "",
					email: v.primary_email,
					salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
					prospect: `${v.primary_first} ${v.primary_last}`,
					sale_date: v.sale_date,
					closing_date: v.closing_date,
					path: (
						<div
							className="btn btn--square text-xs p-1"
							onClick={() => {
								this.setState({ journeyModal: true, journey: v })
							}}>
							View Path
						</div>
					),
				})
			}
		})

		return ret
	}

	buyerJourney = () => {
		const TimelineItem = ({ date, content, isEven }) => (
			<div className="flex items-center mb-8 text-sm">
				<div className="w-1/2 flex justify-end pr-4">
					{isEven ? (
						<span className="text-right">{date}</span>
					) : (
						<span className="text-right font-bold">{content}</span>
					)}
				</div>
				<div className="w-3 h-3 bg-green-600 rounded-full z-10 flex-shrink-0"></div>
				<div className="w-1/2 pl-4">
					{isEven ? <span className="font-bold">{content}</span> : <span className="">{date}</span>}
				</div>
			</div>
		)

		const VerticalTimeline = ({ events }) => {
			return (
				<div className="relative max-w-3xl mx-auto">
					<div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-green-500"></div>
					{events.map((event, index) => (
						<TimelineItem key={index} date={event.date} content={event.content} isEven={index % 2 === 0} />
					))}
				</div>
			)
		}
		let events = []
		let sorted = _.sortBy(this.state.journey?.traffic_entries, "traffic_date")
		_.forEach(sorted, (entry) => {
			let builder = _.find(this.props.payload.public.builders, { id: entry.builder })
			let builderName = builder ? builder.name : "Welcome Center"
			let model = ``
			if (entry.lot_id) {
				let lot = _.find(this.props.payload.exec.lots, { id: entry.lot_id })
				model = ` at model: ${lot.address}`
			}
			events.push({
				date: moment.unix(entry.traffic_date).format("MM/DD/YY"),
				dateStamp: entry.traffic_date,
				content: `Visited: ${builderName}${model}`,
			})
		})
		sorted = _.sortBy(this.state.journey?.leads, "addedDate")
		_.forEach(sorted, (entry) => {
			if (entry.property !== this.state.journey?.property) return
			let sps = []
			_.forEach(entry.emails_sent, (s) => {
				let sp = _.find(this.props.payload.users, { id: s })
				if (sp) {
					sps.push(`${sp.first} ${sp.last}`)
				}
			})
			let builder = _.find(this.props.payload.public.builders, { id: entry.builder })
			let builderName = builder?.name || ""
			let interest = ``
			if (entry.lot_id) {
				let lot = _.find(this.props.payload.exec.lots, { id: entry.lot_id })
				interest = ` for Address: ${lot.address}`
			} else if (entry.floorplan) {
				let floorplan = _.find(this.props.payload.public.floorplans, { id: entry.floorplan })
				interest = ` for Floorplan: ${floorplan.name}`
			}
			events.push({
				date: moment.unix(entry.addedDate).format("MM/DD/YY"),
				dateStamp: entry.addedDate,
				content: `Web Lead: ${builderName}${interest}.  Emails sent to: ${sps.join(", ")} at ${moment
					.unix(entry.addedDate)
					.format("hh:mm A")}`,
			})
		})
		events = _.sortBy(events, "dateStamp")
		// Add sale/closing
		let builder = _.find(this.props.payload.public.builders, { id: this.state.journey?.builder })
		events.push({
			date: moment.unix(this.state.journey?.sale_date).format("MM/DD/YY"),
			content: `Bought ${this.state.journey?.address} with ${builder?.name} for ${numeral(
				this.state.journey?.price
			).format("$0,0")}`,
		})
		events.push({
			date: moment.unix(this.state.journey?.closing_date).format("MM/DD/YY"),
			content: `Closed for ${numeral(this.state.journey?.closing_price).format("$0,0")}`,
		})
		let journeyDays = moment.unix(this.state.journey?.closing_date).diff(moment.unix(events[0].dateStamp), "days")
		let daysToClose = moment
			.unix(this.state.journey?.closing_date)
			.diff(moment.unix(this.state.journey?.sale_date), "days")
		let upgradeDollars = numeral(
			helpers.percentChange(this.state.journey?.price, this.state.journey?.closing_price) / 100
		).format("0.00%")
		return (
			<>
				<h2>
					Buyer Journey for {this.state.journey?.primary_first} {this.state.journey?.primary_last}
				</h2>
				<VerticalTimeline events={events} />
				<div className="flex justify-center">
					<table className="journeyTableStats">
						<thead>
							<tr>
								<th>Journey Days</th>
								<th>Days to Close</th>
								<th>Upgrade Dollars</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{journeyDays}</td>
								<td>{daysToClose}</td>
								<td>{upgradeDollars}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</>
		)
	}

	render() {
		const columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Sale Date",
				accessor: "sale_date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Closing Date",
				accessor: "closing_date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Closing Input Date",
				accessor: "closing_report_time",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
		]
		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Closings" />
					<div className="recentActivity content">
						<h2 style={{ paddingTop: 0 }}>
							{this.props.currentDates.startText} - {this.props.currentDates.endText}
						</h2>
						<FullTable data={this.buildTable()} columns={columns} name="closings" title="Closings" />
						<h2>Detailed Closings</h2>
						<FullTable
							classNames={"small"}
							data={this.buildDetailed()}
							columns={this.state.detailedColumns}
							name="closings__detailed"
							title="Detailed Closings"
						/>
						<h2>Section Totals</h2>
						<FullTable
							classNames={"small"}
							data={this.buildSections()}
							columns={this.state.sectionColumns}
							name="closings__sections"
							title="Closings in Sections"
						/>
						{Array.isArray(this.props.payload.public.neighborhoods) &&
							this.props.payload.public.neighborhoods.length > 1 && (
								<>
									<h2>Neighborhood Totals</h2>
									<FullTable
										classNames={"small"}
										data={this.buildNeighborhoods()}
										columns={this.state.neighborhoodColumns}
										name="closings__neighborhoods"
										title="Closings in Neighborhoods"
									/>
								</>
							)}
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<h2>Buyer Journey</h2>
						<FullTable
							classNames={"small"}
							data={this.buildProspectJourney()}
							columns={this.state.prospectJourney}
							name="closings__prospectJourney"
							title="Prospect Journey"
						/>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.journeyModal}
							onClose={() => this.setState({ journeyModal: false })}
							center>
							{this.buyerJourney()}
						</Modal>
						{_.get(settings, `enabled.contractBasePrices`) && (
							<>
								<h2>Base vs Closing Pricing</h2>
								<FullTable
									classNames={"small"}
									data={this.buildBasePricing()}
									columns={this.state.basePricing}
									name="closings__basevclosing"
									title="Base vs Closing price"
								/>
							</>
						)}
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ClosingsOverview)
